// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-page .copyright,.register-page footer{display:none!important}.link a,.required-star-symbol{color:#ec0608}.register label{color:#1d1d1b!important;font-size:14px}.register label span{color:#9dba48!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
